

















































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../../store/modules/MembershipState'

@Component
export default class ChangeMembershipComplete extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // data
  private gotoMyPageTopURL = ''

  // -------------------------------------------------------------------------------------------------------------------
  // hooks
  private async created() {
    if (!membershipState.isLogin) {
      console.log('no login...')
    }
  }

  private beforeMount() {
    // MyPage TOPのURLを取得
    this.gotoMyPageTopURL =
      drupalSettings.vueComponent.membershipcontroll.myPage.top
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
}
